import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton } from '@mui/material'

import './dialogStyle.css'
import iconAnular from './iconAnular.svg'

import { Buy } from '../../../models/buy'

export const DialogAnular = ({ checkInitialData, setForm, compraId, open, setOpen }) => {

    const handleAnular = async () => {
        await Buy.updateAnular({ id: compraId })
        await checkInitialData(compraId)
        setOpen(false)
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>
                    <img src={iconAnular} alt="arrow" />
                </div>
                <div className='text mt-3'>
                    Confirmar anulación
                </div>
                <p className='p-text-emisor'>Esta acción dará por anulado el gasto. No se considera como gasto real.</p>
            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='approve' onClick={handleAnular}>Sí. Anular</button>
            </DialogActions>
        </Dialog>
    );

}